import ViewBase from "../../view-base.view";
import UserBadgeComponent from "../../../components/common/user-badge.component";
import { workType } from "../../../models/schedule/team-schedule.model";
import modifyScheduleModel from "../../../models/schedule/modify-schedule.model";
import loginModel from "../../../models/login.model";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import { Button, Intent } from "construct-ui";
import moment from "moment";
import _ from "lodash";
import { formats as FORMATS } from '../../../config/constants';

export default function updateSchedule() {

  ViewBase.call(this);

  let scheduleUserDetails;
  let scheduleData;
  let actionType = 0; // 0 - No action | 1 - Change | 2 - Cancel
  let siteList;
  let leaveTypeList;
  let dayOffTypeList;
  let needRefresh = false;
  let isSendToJPO = false;

  let triggerRefresh = (needRefresh, isSendToJPO) => { }
  // let setSendToJPO = () => {}

  let getSiteList = (countryCode, userId) => {
    this.showLoading();
    modifyScheduleModel.getManagedSiteList(
      (result) => {
        // console.log('getManagedSiteList - result', result);
        siteList = result;
        this.hideLoading();
      }, (error) => {
        // console.error("getManagedSiteList - error:", JSON.parse(JSON.stringify(error)));
      }, {
      countryCode,
      userId
    }
    );
  }

  let getLeaveTypeList = () => {
    modifyScheduleModel.getLeaveTypeList(
      (result) => {
        // console.log('getLeaveTypeList - result', result);
        leaveTypeList = [];
        leaveTypeList.push({
          code: '',
          name: this.getText("LT00000201", "Please select"),
        });
        if (result) {
          result.map(t => {
            leaveTypeList.push(t);
          });
        }
      },
      (error) => {
        console.error("getLeaveTypeList - error:", JSON.parse(JSON.stringify(error)));
      }
    )
  }

  let getDayOffTypeList = () => {
    modifyScheduleModel.getDayOffTypeList(
      (result) => {
        // console.log('getDayOffTypeList - result', result);
        dayOffTypeList = [];
        dayOffTypeList.push({
          code: '',
          name: this.getText("LT00000201", "Please select"),
        });
        if (result) {
          result.map(t => {
            dayOffTypeList.push(t);
          });
        }
      },
      (error) => {
        console.error("getDayOffTypeList - error:", JSON.parse(JSON.stringify(error)));
      }
    )
  }

  let saveSchedule = () => {
    modifyScheduleModel.updateSchedule(
      (result) => {
        if (scheduleUserDetails && scheduleUserDetails.userAccess && scheduleUserDetails.userAccess.jpoUser && result && Array.isArray(result) && result[0].code === '001') {
          isSendToJPO = true;
          this.showMessage('There is change(s) to JPO Schedule. Please click on the "Send to JPO" button to send the latest schedules to JPO engine.', null, () => { onClose(false); });
        } else {
          onClose(false);
        }
        needRefresh = true;
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  let cancelSchedule = () => {
    modifyScheduleModel.cancelSchedule(
      (result) => {
        if (scheduleUserDetails && scheduleUserDetails.userAccess && scheduleUserDetails.userAccess.jpoUser && result && Array.isArray(result) && result[0].code === '001') {
          isSendToJPO = true;
          this.showMessage('There is change(s) to JPO Schedule. Please click on the "Send to JPO" button to send the latest schedules to JPO engine.', null, () => { onClose(false); });
        } else {
          onClose(false);
        }
        needRefresh = true;
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  let closeModal = function () {
    onClose(false);
  }

  let onClose = (isModalOpen) => { }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }
      if (vnode.attrs.triggerRefresh) {
        triggerRefresh = vnode.attrs.triggerRefresh;
      }
      scheduleUserDetails = vnode.attrs.scheduleUserDetails;
      scheduleData = vnode.attrs.scheduleData;
      actionType = vnode.attrs.actionType;
      modifyScheduleModel.resetFormDataObj(scheduleData);

      switch (scheduleData.workType) {
        case '001':
          getSiteList(loginModel.credentials.country, scheduleUserDetails.userId);
          break;
        case '002':
          getLeaveTypeList();
          break;
        case '003':
          getDayOffTypeList();
          break;
        default:
      }
    },
    oncreate: (vnode) => {
    },
    onremove: (vnode) => {
      triggerRefresh(needRefresh, isSendToJPO);
    },
    view: (vnode) => {
      return [
        // User badge
        scheduleUserDetails &&
        m('.row',
          m('.col-10.offset-1.col-sm-8.offset-sm-2.mt-3',
            m(UserBadgeComponent, {
              image: scheduleUserDetails.photoString,
            },
              m('.user-text-md', scheduleUserDetails.userName),
            ),
          ),
        ),
        m('hr'),
        scheduleData && [
          m('.row.g-3',
            // Field: Work Type
            m('.col-8.offset-2.col-sm-12.offset-sm-0',
              m('.row.g-sm-4.align-items-center',
                m('.col-4.col-sm-3.text-sm-end',
                  m('label', this.getText("LT00000149", "Work Type"))
                ),
                m('.col-8.col-sm-9',
                  m('.work-type-indicator', {
                    style: {
                      'border-color': workType.getColor(scheduleData.workType),
                      'background-color': workType.getColor(scheduleData.workType),
                    }
                  }),
                  scheduleData.workTypeName,
                ),
              )
            ),
            m('.col-8.offset-2.col-sm-12.offset-sm-0',
              m('.row.g-sm-4.align-items-center',
                m('.col-4.col-sm-3.text-sm-end',
                  m('label', this.getText("LT00001340", "Special Task Type"))
                ),
                m('.col-8.col-sm-9',
                  m('.work-type-indicator', {
                    style: {
                      'background-color': 'transparent',
                      'border-color': 'transparent',
                    }
                  }),
                  scheduleData.leaveDayOffTypeName,
                ),
              )
            ),
            // Field: Date
            m('.col-8.offset-2.col-sm-12.offset-sm-0',
              m('.row.g-sm-4.align-items-center',
                m('.col-sm-3.text-sm-end',
                  m('label', this.getText("LT00000132", "Date"))
                ),
                m('.col-sm-7',
                  actionType === 1 &&
                  m(DatePickerComponent, {
                    class: 'form-control',
                    date: this.dateStringFormat(modifyScheduleModel.formData.scheduleDate), // default date
                    onselect: (e) => {
                      modifyScheduleModel.formData.scheduleDate = moment(e.detail.date).format(FORMATS.dateFormat);
                      // console.log('modifyScheduleModel.formData.scheduleDate: ' + modifyScheduleModel.formData.scheduleDate);
                    }
                  }),
                  actionType === 2 &&
                  this.dateStringFormat(scheduleData.scheduleDate),
                ),
              )
            ),
            // Field: Site
            scheduleData.workType === '001' && // Work
            m('.col-8.offset-2.col-sm-12.offset-sm-0',
              m('.row.g-sm-4.align-items-center',
                m('.col-sm-3.text-sm-end',
                  m('label[for=siteCode]', this.getText("LT00000071", "Site"))
                ),
                m('.col-sm-7',
                  actionType === 1 && [
                    m('select#siteCode.form-select', {
                      value: modifyScheduleModel.formData.siteId,
                      onchange: (e) => {
                        modifyScheduleModel.formData.siteId = siteList[e.target.selectedIndex].siteCode
                      }
                    },
                      siteList && siteList.map(site => [
                        m('option', {
                          value: site.siteCode,
                          selected: site.siteCode == modifyScheduleModel.formData.siteId
                        },
                          site.siteName
                        )
                      ])
                    )
                  ],
                  actionType === 2 && [
                    scheduleData.siteName
                  ]
                ),
              )
            ),
            // Field: Leave Type
            scheduleData.workType === '002' && // Leave
            m('.col-8.offset-2.col-sm-12.offset-sm-0',
              m('.row.g-sm-4.align-items-center',
                m('.col-sm-3.text-sm-end',
                  m('label[for=leaveType]', this.getText("LT00000160", "Leave Type"))
                ),
                m('.col-sm-7',
                  actionType === 1 && [
                    m('select#leaveType.form-select', {
                      value: modifyScheduleModel.formData.leaveDayOffType,
                      onchange: (e) => {
                        modifyScheduleModel.formData.leaveDayOffType = leaveTypeList[e.target.selectedIndex].code
                      }
                    },
                      leaveTypeList && leaveTypeList.map(t => [
                        m('option', {
                          value: t.code,
                          selected: t.code == modifyScheduleModel.formData.leaveDayOffType
                        },
                          t.name
                        )
                      ])
                    )
                  ],
                  actionType === 2 && [
                    scheduleData.leaveDayOffTypeName
                  ]
                ),
              )
            ),
            // Field: Day Off Type
            scheduleData.workType === '003' && // Day Off
            m('.col-8.offset-2.col-sm-12.offset-sm-0',
              m('.row.g-sm-4.align-items-center',
                m('.col-sm-3.text-sm-end',
                  m('label[for=dayOffType]', this.getText("LT00000204", "Day Off Type"))
                ),
                m('.col-sm-7',
                  actionType === 1 && [
                    m('select#dayOffType.form-select', {
                      value: modifyScheduleModel.formData.leaveDayOffType,
                      onchange: (e) => {
                        modifyScheduleModel.formData.leaveDayOffType = dayOffTypeList[e.target.selectedIndex].code
                      }
                    },
                      dayOffTypeList && dayOffTypeList.map(t => [
                        m('option', {
                          value: t.code,
                          selected: t.code == modifyScheduleModel.formData.leaveDayOffType
                        },
                          t.name
                        )
                      ])
                    )
                  ],
                  actionType === 2 && [
                    scheduleData.leaveDayOffTypeName
                  ]
                ),
              )
            ),
            // Field: Start / End Time
            scheduleData.workType !== '006' && // When Work Type is not Others
            !(scheduleData.workType === '002' && !(modifyScheduleModel.formData.leaveDayOffType === '002' || modifyScheduleModel.formData.leaveDayOffType === '003')) && // When Leave Type is not AM / PM
            !(scheduleData.workType === '003' && !(modifyScheduleModel.formData.leaveDayOffType === '002' || modifyScheduleModel.formData.leaveDayOffType === '003')) && // When Day Off Type is not AM / PM
            // !(actionType === 2 && _.isEmpty(modifyScheduleModel.formData.startTime)) &&
            m('.col-8.offset-2.col-sm-12.offset-sm-0',
              m('.row.g-sm-4.align-items-center',
                m('.col-sm-3.text-sm-end',
                  m('label', this.getText("LT00000182", "Working Hours"))
                ),
                m('.col-sm-7',
                  actionType === 1 && [
                    m('.d-flex.align-items-center', { style: 'gap: 1em;' },
                      m('.flex-grow-1',
                        m('input.form-control[type=time]', {
                          value: modifyScheduleModel.formData.startTime,
                          onchange: e => modifyScheduleModel.formData.startTime = e.target.value
                        }),
                      ),
                      m('.text-center', { style: 'width: 1.5em;' }, ' ~ '),
                      m('.flex-grow-1',
                        m('input.form-control[type=time]', {
                          value: modifyScheduleModel.formData.endTime,
                          onchange: e => modifyScheduleModel.formData.endTime = e.target.value
                        }),
                      ),
                    ),
                  ],
                  actionType === 2 && [
                    `${scheduleData.startTime} ~ ${scheduleData.endTime} (${scheduleData.breakHour})`
                  ]
                ),
              )
            ),
            // Field: Break Hours
            scheduleData.workType === '001' && // Work
            actionType === 1 && [
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label', this.getText("LT00000207", "Break Hours"))
                  ),
                  m('.col-sm-7',
                    m('.d-flex.align-items-center', { style: 'gap: 1em;' },
                      m('.flex-grow-1',
                        m('input.form-control[type=number][inputmode=numeric]', {
                          value: modifyScheduleModel.formData.hourOfBreakHour,
                          onchange: e => {
                            modifyScheduleModel.formData.hourOfBreakHour = e.target.value;
                          }
                        }),
                      ),
                      m('.text-center', { style: 'width: 1.5em;' }, ' : '),
                      m('.flex-grow-1',
                        m('input.form-control[type=number][inputmode=numeric]', {
                          value: modifyScheduleModel.formData.minuteOfBreakHour,
                          onchange: e => {
                            modifyScheduleModel.formData.minuteOfBreakHour = e.target.value;
                          }
                        }),
                      ),
                    ),
                  ),
                )
              )
            ],
            scheduleData.workType !== '002' && scheduleData.workType !== '003' && [ // Not 'Leave' / 'Day Off'
              // Field: Staff Remarks
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label', this.getText("LT00000347", "Staff Remarks")),
                  ),
                  m('.col-sm-7',
                    _.isEmpty(scheduleData.remarks) ? ' - ' : scheduleData.remarks
                  ),
                )
              ),
              // Field: Supervisor Remarks
              actionType === 2 &&
              m('.col-8.offset-2.col-sm-12.offset-sm-0',
                m('.row.g-sm-4.align-items-center',
                  m('.col-sm-3.text-sm-end',
                    m('label', this.getText("LT00000183", "Supervisor Remarks")),
                  ),
                  m('.col-sm-7',
                    m('textarea.form-control', {
                      onchange: e => {
                        modifyScheduleModel.formData.supervisorRemarks = e.target.value;
                      }
                    }),
                  ),
                )
              ),
            ]
          ),
          m('.d-flex.justify-content-end.mb-1.mt-4', { style: 'gap: 0.75em' },
            actionType === 1 &&
            m(Button, {
              intent: Intent.PRIMARY,
              label: this.getText("LT00000022", "Save"),
              onclick: saveSchedule
            }),
            actionType === 2 &&
            m(Button, {
              intent: Intent.PRIMARY,
              label: this.getText("LT00000208", "Cancel Schedule"),
              onclick: cancelSchedule
            }),
            m(Button, {
              outlined: true,
              label: this.getText("LT00000021", "Close"),
              onclick: closeModal
            })
          )
        ],
        this.getBaseViews()
      ]
    }
  }
}